import { Action } from '@ngrx/store';
import { AddressBookSearchParams } from './address-book-params.interface';
import { AddressBookResponse } from './model/address-book.model';
import { PaginatedData } from '../shared/models/table';

export const GET_ADDRESS_BOOK = 'GET_ADDRESS_BOOK';
export const GET_ADDRESS_BOOK_SUCCESS = 'GET_ADDRESS_BOOK_SUCCESS';
export const GET_ADDRESS_BOOK_FAILURE = 'GET_ADDRESS_BOOK_FAILURE';
export const SET_ADDRESS_BOOK_PARAMS = 'SET_ADDRESS_BOOK_PARAMS';
export const RESET_ADDRESS_BOOK = 'RESET_ADDRESS_BOOK';

export class GetAddressBookAction implements Action {
  readonly type = GET_ADDRESS_BOOK;

  constructor(public payload: AddressBookSearchParams) {}
}

export class GetAddressBookSuccessAction implements Action {
  readonly type = GET_ADDRESS_BOOK_SUCCESS;

  constructor(public payload: PaginatedData<AddressBookResponse>) {}
}

export class GetAddressBookFailureAction implements Action {
  readonly type = GET_ADDRESS_BOOK_FAILURE;

  constructor(public payload: any) {}
}

export class SetAddressBookParamsAction implements Action {
  readonly type = SET_ADDRESS_BOOK_PARAMS;

  constructor(public payload: AddressBookSearchParams) {}
}

export class ResetAddressBookAction implements Action {
  readonly type = RESET_ADDRESS_BOOK;

  constructor() {}
}

export type AddressBookActions =
  | GetAddressBookAction
  | GetAddressBookSuccessAction
  | GetAddressBookFailureAction
  | SetAddressBookParamsAction
  | ResetAddressBookAction;
